export const deliveryPartnerInfo = {
  farmerPartnerId: "",
  deliveryPartnerName: "",

  email: "",
  contactNumber: "",
  alternateContactNumber: "",

  addressLine1: "",
  addressLine2: "",

  village: "",
  city: "",
  state: "",
  pincode: "",
  landmark: "",

  vehicleType: "",
  vehicleNumber: "",
  drivingLicenseNumber: "",

  drivingLicenseImage: null,
  profileImage: null,

  notes: "",

  isActive: true,
  isAvailable: false,
};
